<template>
    <div id="app">
        <div class="root-wrap">
            <MenuAssets />

            <!-- slotに読込元のファイルが入る -->
            <main class="ly_end-user-main">
                <slot />
            </main>

            <div class="modal_bg"></div>
            <div class="md_cursor"><span></span></div>
            <div class="md_cursor-follower"><span></span></div>

            <Footer />
        </div>
    </div>
</template>

<script>
import MenuAssets from '@/components/EndUser/MenuAssets'
import Footer from '@/components/EndUser/PartsFooter'

export default {
    components: {
        MenuAssets,
        Footer,
    },
};
</script>
